import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewSettings: {
		id: 'roadmap.standard-roadmap.header.view-settings.button.view-settings',
		defaultMessage: 'View settings',
		description: 'Button label. Opens the view settings popup.',
	},
});
